export const buildDonorQuery = (filterObj, currentPage, selectedFields) => {
  const params = new URLSearchParams();

  Object.entries(filterObj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v));
    } else if (value) {
      params.append(key, value);
    }
  });

  params.append("page", currentPage);
  params.append("attributes", selectedFields);

  return params.toString();
};

export const buildDonorPayload = (userDetailsFormData) => ({
  donor_id: userDetailsFormData.donorId,
  fullName: userDetailsFormData.fullName,
  initiatedName: userDetailsFormData.initiatedName,
  phoneNumber: userDetailsFormData.phoneNumber,
  email: userDetailsFormData.email,
  mentorId: userDetailsFormData.mentorId,
  mentorsName: userDetailsFormData.mentorsName,
  gender: userDetailsFormData.gender,
  processingAgency: userDetailsFormData.processingAgency,
  city: userDetailsFormData.city,
  donor_category: userDetailsFormData.donor_category || "voice",
  country: userDetailsFormData.country,
  state: userDetailsFormData.state,
  zipCode: userDetailsFormData.zipCode,
  totalDonation: userDetailsFormData.totalDonation,
  dateOfBirth: userDetailsFormData.dateOfBirth,
  address: userDetailsFormData.address,
  permanentAddress: userDetailsFormData.permanentAddress,
  mode: userDetailsFormData.mode,
  donorType: userDetailsFormData.donation_type,
  startDate: userDetailsFormData.startDate,
  stopHoldDate: userDetailsFormData.stopHoldDate,
  panNo: userDetailsFormData.panNo,
  want80G: userDetailsFormData.want80G,
  deductionDay: userDetailsFormData.deductionDay,
});

export const mapDonorApiToFormData = (data) => ({
  donorId: data.donor_id || "",
  fullName: data.user_full_name || "",
  initiatedName: data.initiated_name || "",
  phoneNumber: data.phone_number || "",
  email: data.email || "",
  mentorId: data.mentor_id || "",
  mentorsName: data.mentors_name || "",
  gender: data.gender || "",
  processingAgency: data.processing_agency || data.processingAgency || "",
  city: data.city || "",
  donor_category: data.donor_category || "voice",
  country: data.country || "",
  state: data.state || "",
  zipCode: data.zip_code || "",
  totalDonation: data.total_donation || "",
  dateOfBirth: data.date_of_birth || "",
  address: data.residential_address || "",
  permanentAddress: data.permanent_address || "",
  mode: data.mode || "",
  donation_type: data.donation_type || "",
  startDate: data.start_date || "",
  stopHoldDate: data.stop_date || "",
  panNo: data.pan_no || "",
  want80G: data.want_80g || "",
  deductionDay: data.deduction_day || "",
});

export const downloadFailedRowsExcel = (failedExcelBase64) => {
  if (!failedExcelBase64) return;

  const binaryString = atob(failedExcelBase64);
  const bytes = new Uint8Array(binaryString.length);

  for (let i = 0; i < binaryString.length; i += 1) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  const blob = new Blob([bytes], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "failed_rows.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
